module.exports = __webpack_public_path__ + "2c7982cc7cad817a3790df219b4af2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/marquise.png
// module id = 768
// module chunks = 0